<template>
  <div class="view-exercise">
    <container>
      <h1>{{exercise.title}}</h1>
      <p class="manchette"> 
        {{{exercise.intro}}}
      </p>
      
      <h4>Organisation</h4>
      {{{exercise.organisation}}}
      
      <h4>Udstyr</h4>
      {{{exercise.gear}}}
      
      <h4>Variationer</h4>
      {{{exercise.possibilities}}}
      
      <h4>Beskrivelse</h4>
      {{{exercise.description}}}

      <h4>Fra træning til hverdag</h4>
      {{{exercise.note}}}
      
      <div class="video" v-if="exercise.video">
        <vimeo :video-id="exercise.video"></vimeo>
        <h4>
          <a href="{{exercise.video}}" target="_blank" class="color-tint">Gå til video &rarr;</a>
        </h4>
      </div>

      <h2>Progressioner</h2>
      <subexercise
        v-for="subexercise in exercise.exercises"
        :exercise="subexercise" 
        :index="$index">
      </subexercise>
    </container>

  </div>
</template>

<script>
import view from '../mixins/view'
import { getExercise } from '../vuex/exercises/actions'
import { activeExercise } from '../vuex/exercises/getters'

import Container from '../components/Container.vue'
import FlipButton from '../components/FlipButton.vue'
import Subexercise from '../components/SubExercise.vue'
import Vimeo from 'components/Vimeo'

export default {
  name: 'ExerciseView',
  mixins: [view],
  data () {
    return {
      enableTransition: true
    }
  },
  components: {
    Container,
    FlipButton,
    Subexercise,
    Vimeo
  },
  ready () {
    this.getExercise(this.$route.params.id)
  },
  computed: {
    title () {
      return this.exercise.title
    }
  },
  vuex: {
    actions: {
      getExercise
    },
    getters: {
      exercise: activeExercise
    }
  }
}
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 2rem;
}
.subexercise {
  margin-bottom: 4rem;
}
.video, h2 {
  margin: 4rem 0;
}
</style>



// WEBPACK FOOTER //
// ExerciseView.vue?ea3ca104